import { createFileRoute } from "@tanstack/react-router";
import { Header, Footer } from "@/components/layout";
import { buildMeta } from "@/lib/seo";

export const Route = createFileRoute("/regulamin")({
  component: TermsPage,
  head: () => buildMeta({
    title: "Regulamin serwisu | Tanie Latanie",
    description: "Regulamin korzystania z serwisu tanielatanie.pl — zasady działania porównywarki lotów, prawa i obowiązki użytkowników.",
    path: "/regulamin",
  }),
});

function TermsPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <article className="container mx-auto max-w-3xl px-4 py-10 prose prose-invert">
        <h1 className="font-display text-4xl font-bold">Regulamin</h1>
        <p className="text-muted-foreground">Ostatnia aktualizacja: {new Date().toLocaleDateString("pl-PL")}</p>

        <h2>1. Postanowienia ogólne</h2>
        <p>Serwis tanielatanie.pl jest porównywarką cen biletów lotniczych — agregujemy oferty wszystkich linii lotniczych świata oraz biur podróży online. Sprzedaż biletów oraz zawarcie umowy przewozu odbywa się wyłącznie u naszych partnerów (biur podróży online) lub bezpośrednio u przewoźnika.</p>

        <h2>2. Zakres usług</h2>
        <p>Umożliwiamy bezpłatne wyszukiwanie i porównanie ofert lotów, prezentację treści informacyjnych oraz przekierowanie do partnera w celu finalizacji rezerwacji.</p>

        <h2>3. Ceny i dostępność</h2>
        <p>Ceny prezentowane w serwisie pochodzą z systemów partnera i mogą ulec zmianie do momentu finalizacji rezerwacji. Nie odpowiadamy za różnice w cenie lub dostępności biletów po przejściu na stronę partnera.</p>

        <h2>4. Odpowiedzialność</h2>
        <p>Serwis nie jest stroną umowy przewozu. Wszelkie reklamacje dotyczące biletów, lotów, opóźnień i bagażu należy kierować bezpośrednio do partnera lub przewoźnika.</p>

        <h2>5. Prawa autorskie</h2>
        <p>Treści publikowane w serwisie (opisy kierunków, przewodniki) są chronione prawem autorskim. Kopiowanie i publikowanie bez zgody jest zabronione.</p>

        <h2>6. Kontakt</h2>
        <p>W sprawach związanych z funkcjonowaniem serwisu prosimy o kontakt poprzez formularz w zakładce Kontakt.</p>
      </article>
      <Footer />
    </div>
  );
}
